import { HttpResponse } from '@angular/common/http';

export function extractFileNameFromContentDisposition(response: HttpResponse<Blob>): string | null {
  const disposition = response.headers.get('Content-Disposition') || response.headers.get('content-disposition');
  let resolvedName = null;

  if (disposition) {
    // Try to extract filename from Content-Disposition
    // Supports both filename="..." and filename*=UTF-8''...
    const filenameStarMatch = /filename\*=([^']*)''([^;\n]+)/i.exec(disposition);
    const filenameQuotedMatch = /filename="?([^";\n]+)"?/i.exec(disposition);

    if (filenameStarMatch && filenameStarMatch[2]) {
      try {
        resolvedName = decodeURIComponent(filenameStarMatch[2]);
      } catch {
        resolvedName = filenameStarMatch[2];
      }
    } else if (filenameQuotedMatch && filenameQuotedMatch[1]) {
      resolvedName = filenameQuotedMatch[1];
    }
  }

  return resolvedName;
}
